import { IDeliveryTarget } from "src/app/core/models/i-delivery-target";


export function siteNameByCode(
  deliveryTargets: IDeliveryTarget[],
  targetCodes: string[]
): string {
  const friendlyNames: string[] = [];

  targetCodes.forEach((targetCode) => {
    const section = deliveryTargets.find(
      (section) => section.code === targetCode
    );

    if (section) {
      friendlyNames.push(section.friendlyName);
    }
  });

  return friendlyNames.join(', ');
}
